// interviewsApi.js
import api from '../api'; // Import your configured axios instance

export const getAllInterviews = async () => {
  try {
    const response = await api.get('/interviews');
    console.log('getAllInterviews response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching all interviews:', error.response?.data || error.message);
    throw error;
  }
};

export const getInterviewsByCandidate = async (candidateId) => {
  try {
    const response = await api.get(`/interviews/candidate/${candidateId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching interviews by candidate:', error.response?.data || error.message);
    throw error;
  }
};

export const createInterview = async (interviewData) => {
  try {
    const response = await api.post('/interviews', {
      ...interviewData,
      status: interviewData.status?.toUpperCase(),
      location: interviewData.location?.toUpperCase(),
      round: interviewData.round?.toUpperCase(),
    });
    return response.data;
  } catch (error) {
    console.error('Error creating interview:', error.response?.data || error.message);
    throw error;
  }
};

export const updateInterview = async (interviewId, interviewData) => {
  try {
    const payload = {
      ...interviewData,
      status: interviewData.status?.toUpperCase(),
      location: interviewData.location?.toUpperCase(),
      round: interviewData.round?.toUpperCase(),
      type: interviewData.type?.toUpperCase(),
      priority: interviewData.priority?.toUpperCase(),
    };
    
    // Remove undefined fields
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    
    const response = await api.put(`/interviews/${interviewId}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating interview:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteInterview = async (interviewId) => {
  try {
    await api.delete(`/interviews/${interviewId}`);
    return { success: true };
  } catch (error) {
    console.error('Error deleting interview:', error.response?.data || error.message);
    throw error;
  }
};

export const getInterviewsStatistics = async () => {
  try {
    const response = await api.get('/interviews/statistics');
    return response.data;
  } catch (error) {
    console.error('Error fetching interview statistics:', error.response?.data || error.message);
    throw error;
  }
};